export default function getOgImage(ogImage) {
  const siteUrl = "https://cormo.pl";
  const ogImageUrl = `${siteUrl}${ogImage?.publicURL ?? ""}`;

  return ogImageUrl;
}
